<span [class]="'text-xs font-bold rounded-full py-0.5 px-2 whitespace-nowrap ' + badgeClass()">
  {{ 'invoice-state.' + state() | translate }}
</span>
